import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import CustomScrollbar from '@sls-react/components/CustomScrollbar';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const FeatheredOverflowContainer = React.forwardRef<HTMLDivElement, Props>(
  ({ children, className }, ref) => {
    const [feathers, setFeathers] = useState({ left: false, right: true });
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (!containerRef.current) {
        return;
      }

      const node = containerRef.current;

      function scrollHandler() {
        if (!containerRef.current) {
          return;
        }

        const newFeathers = { ...feathers };

        newFeathers.right =
          node.scrollLeft + node.clientWidth < node.scrollWidth - 12;

        newFeathers.left = node.scrollLeft > 12;

        if (
          newFeathers.left !== feathers.left ||
          newFeathers.right !== feathers.right
        ) {
          setFeathers(newFeathers);
        }
      }

      node.addEventListener('scroll', scrollHandler);

      return () => node?.removeEventListener('scroll', scrollHandler);
    }, [feathers]);

    useImperativeHandle(ref, () => containerRef.current!, []);

    const featherCx =
      'absolute top-0 z-10 w-4 h-full pointer-events-none from-white dark:from-black';

    return (
      <div className="relative">
        {feathers.left && (
          <div className={`${featherCx} left-0 bg-gradient-to-r`} />
        )}
        <div
          className={`flex overflow-x-auto pr-2 ${className}`}
          ref={containerRef}
        >
          {children}
        </div>
        {feathers.right && (
          <div className={`${featherCx} right-0 bg-gradient-to-l`} />
        )}
      </div>
    );
  },
);

export default FeatheredOverflowContainer;
